
import FormOption from '@/components/Form/FormOption.vue'
import RandselDialog from '@/components/Abstract/RandselDialog.vue'
import { computed, defineComponent, inject, ref, watch } from 'vue'
import bagsizeSettings from '@/settings/bagsize-settings.json'
import { useStore } from '@/store'

export default defineComponent({
  name: 'MobileBagtypeDialog',
  components: {
    FormOption,
    RandselDialog
  },
  setup() {
    const store = useStore()
    const emitter: any = inject('emitter')
    const options = computed(() => {
      return [bagsizeSettings.bagsizeOptions[0], bagsizeSettings.bagsizeOptions[1]]
    })
    const configBagsizeId = computed(() => store.getters.configBagsizeId)
    let currentSelection = ref()
    let root = ref<InstanceType<typeof RandselDialog>>()

    // prettier-ignore
    watch(() => configBagsizeId.value, (config) => {
        currentSelection.value = config;
      }
    )

    const onClick = (option: any) => {
      emitter.emit('chooseMobileBagtype', option)
      root.value?.hideDialog()
    }

    return {
      root,
      options,
      onClick,
      currentSelection
    }
  }
})
